import { useMemo } from 'react'

import { useApiClient } from 'clients/yogi-api'
import { SourcePageService } from 'features/sourcepage/service/service'

export { SourcePageService } from 'features/sourcepage/service/service'

export function useSourcePageService(): SourcePageService {
  const client = useApiClient()
  return useMemo(() => new SourcePageService(client), [client])
}
